import React, { useEffect } from "react";
import "./AppReplayer.scss";

function AppReplayer(props) {
  useEffect(() => {
    return () => {
      console.log("AppReplayer effect done");
    };
  });

  return <div id="app-replayer">sqSQs</div>;
}
export default AppReplayer;
